module.exports = __webpack_public_path__ + "img/qfqz-icon.79d6b0b4.png";